// extracted by mini-css-extract-plugin
export default {"success":"SuccessPage_success__sDKgR"};